import React from 'react'
import { Input } from 'react-bootstrap'
import Select from './select'
import SelectAjax from './selectAjax'
import Toggle from './toggle'
import DatePicker from './datePicker'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'

/**
 * A Bs.Input but works with server validations
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class ValidateInput extends React.Component {
  static propTypes = {
    errors: React.PropTypes.object,
    name: React.PropTypes.string,
    help: React.PropTypes.string,
    type: React.PropTypes.string
  }

  renderCustom (props) {
    const { label, type, ...other } = props

    let customEl = null
    switch (type) {
      case 'text-multi':
        customEl = <Select allowCreate multi {...other} />
        break
      case 'select':
        customEl = <Select {...other} />
        break
      case 'select-ajax':
        customEl = <SelectAjax {...other} />
        break
      case 'switch':
        customEl = <Toggle label={label} {...other} />
        delete props.label
        break
      case 'date':
        customEl = <DatePicker {...other} />
    }

    return customEl
  }

  render() {
    const props = Object.assign({}, this.props)
    const { name, errors = {}, help } = props
    const error = errors[name] || errors[name+'.value']

    const customEl = this.renderCustom(props)
    if (customEl) delete props.type

    return (
      <Input
        {...props}
        bsStyle={error ? 'error' : null}
        help={error || help}>
        {customEl}
      </Input>
    )
  }
}

export default ValidateInput



// WEBPACK FOOTER //
// ./modules/shared/components/input.js